// extracted by mini-css-extract-plugin
export default {"container":"ContactSection_container__hwrP-","title":"ContactSection_title__SFBp9"};